import { Component, Input, OnInit, OnChanges } from '@angular/core';
import * as moment from 'moment';

import { LanguageService } from '../../../../navigation/language.service';

@Component({
  selector: 'app-month-weeks-interest-table',
  templateUrl: './month-weeks-interest-table.component.html',
  styleUrls: ['./month-weeks-interest-table.component.scss']
})
export class MonthWeeksInterestTableComponent implements OnInit, OnChanges {
  dataSource: any[] = [];
  displayedColumns: string[] = ['region'];
  language = 'en';

  @Input() group: any;
  @Input() groupBy: 'week' | 'month' = 'week';

  constructor(private languageService: LanguageService) {
    this.language = this.languageService.getLanguage();
    this.languageService.onLanguageChange.subscribe(v => {
      this.language = v;
    });
  }

  ngOnInit(): void {
    this.prepareTable();
  }

  ngOnChanges(): void {
    this.prepareTable();
  }

  private prepareTable(): void {
    const edges = this.group?.metricvalueSet?.edges;
    const periodSet = new Set<string>();
    const regionMap = new Map<string, any>();

    edges?.forEach((edge: any) => {
      const node = edge?.node;
      if (!node?.date || !node?.regionGroup?.title) {
        return;
      }

      const region = node.regionGroup.title;
      const date = moment(node.date);
      const period =
        this.groupBy === 'week'
          ? `W${date.isoWeek()} ${date.year()}`
          : date.format('YYYY-MM');

      periodSet.add(period);

      if (!regionMap.has(region)) {
        regionMap.set(region, { region, _cellAgg: {} as Record<string, { sum: number; count: number }> });
      }

      const regionEntry = regionMap.get(region);
      if (!regionEntry._cellAgg[period]) {
        regionEntry._cellAgg[period] = { sum: 0, count: 0 };
      }
      const cell = regionEntry._cellAgg[period];
      cell.sum += Number(node.value || 0);
      cell.count += 1;
    });

    const sortedPeriods = Array.from(periodSet).sort((a, b) => {
      const aDate = this.getDateFromPeriod(a);
      const bDate = this.getDateFromPeriod(b);
      return aDate.diff(bDate);
    });

    this.displayedColumns = ['region', ...sortedPeriods];
    for (const row of regionMap.values()) {
      const agg = row._cellAgg;
      for (const p of sortedPeriods) {
        const cell = agg[p];
        row[p] = cell && cell.count > 0 ? cell.sum / cell.count : undefined;
      }
      delete row._cellAgg;
    }
    this.dataSource = Array.from(regionMap.values());
  }

  private getDateFromPeriod(period: string): moment.Moment {
    if (this.groupBy === 'week') {
      const match = period.match(/W(\d+)\s(\d+)/);
      const week = parseInt(match[1], 10);
      const year = parseInt(match[2], 10);
      return moment().year(year).isoWeek(week).startOf('isoWeek');
    } else {
      return moment(period, 'YYYY-MM');
    }
  }

  formatDate(value) {
    if (this.groupBy === 'month') {
      return moment(value, 'YYYY-MM').locale(this.language).format('MMM YYYY');
    } else {
      return value;
    }
  }
}
